var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('load-profile'),[_c('div',{staticClass:"ticket-center-main"},[_c('ListBot')],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }